// @flow

import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { equals } from 'ramda'
import { isNilOrEmpty } from 'ramda-adjunct'

import { getMediaStreams } from '@alphaott/app-channels/selectors'

export const useMediaStreams = (channelId: string) => {
  const mediaStreams = useSelector(getMediaStreams(channelId), equals)

  const cachedMediaStreams = useMemo(() => mediaStreams, [channelId, mediaStreams]) // eslint-disable-line react-hooks/exhaustive-deps

  return useMemo(
    () => (isNilOrEmpty(cachedMediaStreams) ? mediaStreams : cachedMediaStreams),
    [cachedMediaStreams, mediaStreams],
  )
}

export default useMediaStreams
